import gql from "graphql-tag";

export const checkYearInReviewStatus = `summonerReviewStatus (regionId: $regionId, summonerName: $summonerName, season: $season) {
    status
  }`;

export const CHECK_YIR_STATUS = gql`
    query SummonerReviewStatus (
        $summonerName: String!,
        $regionId: String!,
        $season: Int
    ) {
        ${checkYearInReviewStatus}
    }
`;

export default CHECK_YIR_STATUS;
